export enum RubricTypes {
  Points = 'points',
  CommentsOnly = 'comments_only',
  CriteriaWithPoints = 'criteria_with_points',
  AchievementLevel = 'myp_achievement_level',
  Custom = 'custom',
}

/**
 * Rubric types that do not have points and therefore should not display
 * the "Pts" tag in assessment detail views.
 */
export const RUBRIC_TYPES_WITHOUT_POINTS: RubricTypes[] = [
  RubricTypes.CommentsOnly,
  RubricTypes.AchievementLevel,
  RubricTypes.Custom,
];

/**
 * True when the experience's `topics` tree (GET /experiences/:id attribute)
 * holds ≥1 QUESTION segment at any depth — text/section children don't
 * count. Drives the custom-rubric structure lock (APL-11850 audit H4).
 */
export const topicsHaveQuestionSegments = (nodes: unknown): boolean =>
  Array.isArray(nodes) &&
  nodes.some(
    (node: any) =>
      node?.segment_type === 'question' || topicsHaveQuestionSegments(node?.children)
  );
